import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UndoRemoveAssetsFromShareMutationVariables = Types.Exact<{
  input: Types.UndoRemoveAssetsFromShareInput;
}>;


export type UndoRemoveAssetsFromShareMutation = { __typename?: 'Mutation', undoRemoveAssetsFromShare?: { __typename?: 'UndoRemoveAssetsFromSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, name: string, aggregationInfo: { __typename?: 'AssetAggregateAggregationInfo', fileCount: number, folderCount: number }, thumbnailAssets?: Array<{ __typename?: 'InboxItemAsset', id?: string | null, assetType?: Types.AssetTypeEnum | null } | null> | null } | { __typename?: 'CollectionShare', id: string, name: string, aggregationInfo: { __typename?: 'AssetAggregateAggregationInfo', fileCount: number, folderCount: number } } | null, metadata?: { __typename?: 'UndoRemoveAssetsFromShareMetadata', restoredAssetIds: Array<string> } | null } | null };


export const UndoRemoveAssetsFromShare = /*#__PURE__*/ gql`
    mutation UndoRemoveAssetsFromShare($input: UndoRemoveAssetsFromShareInput!) {
  undoRemoveAssetsFromShare(input: $input) {
    share {
      id
      name
      ... on AssetAggregate {
        aggregationInfo {
          fileCount
          folderCount
        }
      }
      ... on AdHocAssetsShare {
        thumbnailAssets {
          id
          assetType
        }
      }
    }
    metadata {
      restoredAssetIds
    }
  }
}
    ` as unknown as DocumentNode<UndoRemoveAssetsFromShareMutation, UndoRemoveAssetsFromShareMutationVariables>;

          

          export const useUndoRemoveAssetsFromShareMutation = (options?:MutationHookOptions<UndoRemoveAssetsFromShareMutation, UndoRemoveAssetsFromShareMutationVariables>) => useMutation(UndoRemoveAssetsFromShare, options);
          

          export type UndoRemoveAssetsFromShareMutationOptions = MutationHookOptions<UndoRemoveAssetsFromShareMutation, UndoRemoveAssetsFromShareMutationVariables>;

          

          export type UndoRemoveAssetsFromShareMutationResult = ReturnType<typeof useUndoRemoveAssetsFromShareMutation>[1];

          
